<a class="card card--clickable service-tile" [routerLink]="serviceRoute()">
  <div class="card__container">
    @if (isLoading()) {
      <div class="card__container">
        <span class="service-tile__icon-container service-tile__available">
          <svg-icon src="assets/images/icons/{{ serviceIcon() }}.svg" class="service-tile__icon"></svg-icon>
        </span>
        <h3 class="service-tile__title">{{ serviceTitle() }}</h3>
        <div class="card__content">
          <ngx-skeleton-loader class="card__placeholder-message" count="1"></ngx-skeleton-loader>
          <ngx-skeleton-loader
            count="1"
            appearance="circle"
            [theme]="{
              height: '20px',
              width: '20px',
            }"
          ></ngx-skeleton-loader>
        </div>
      </div>
    } @else {
      <span class="service-tile__icon-container service-tile__{{ serviceIcon() }}">
        <svg-icon src="assets/images/icons/{{ serviceIcon() }}.svg" class="service-tile__icon"></svg-icon>
        @if (firewallCount() > 0) {
          <span class="service-tile__overlap">
            <span class="service-tile__overlap-square">
              <div class="service-tile__overlap-tooltip">
                {{ firewallCount() }} {{ "Subscription.FW.Tooltip" | translate }}
              </div>
              <svg-icon src="assets/images/icons/fw-overlap.svg" class="service-tile__overlap-icon"></svg-icon>
            </span>
            <span class="service-tile__overlap-text">{{ firewallCount() }} firewalls</span>
          </span>
        }
      </span>

      <h3 class="service-tile__title">{{ serviceTitle() }}</h3>
      <div class="card__content">
        @if (!isIpPrefix() && !isCert() && !isDomains() && !isIotNet()) {
          <span>
            @switch (serviceMessage()?.category) {
              @case ("Malfunction") {
                <div class="green" (click)="openDialog($event)">
                  {{ "Subscription.Message.Malfunction" | translate }}
                </div>
              }
              @case ("PlannedWork") {
                <div class="blue" (click)="openDialog($event)">
                  {{ "Subscription.Message.PlannedWork" | translate }}
                </div>
              }
              @case ("General") {
                <div class="red" (click)="openDialog($event)">
                  {{ "Subscription.Message.General" | translate }}
                </div>
              }
              @default {
                <p>{{ "Subscription.Message.None" | translate }}</p>
              }
            }
          </span>
        }
        @if (isDomains()) {
          <p>{{ "Subscription.domains.Description" | translate }}</p>
        }

        @if (isIotNet()) {
          <p>{{ "Subscription.iotnet.Description" | translate }}</p>
        }

        @if (isIpPrefix()) {
          <span>
            <p>{{ subscriptionCount() }} {{ "Global.Active" | translate }}</p>
          </span>
        }

        @if (isCert()) {
          <span>{{ "Cert.DDoS.CTA" | translate }} {{ "Global.CTA.Here" | translate }}</span>
        }

        <div class="service-tile__bottom">
          @if (isIpPrefix() || isDomains() || isIotNet()) {
            <div target="_blank" class="service-tile__more-info">
              <strong>{{ actionButtonText() | translate }}</strong>
            </div>
          }
          @if (hasHealthIndicators()) {
            <health-indicators [indicators]="healthIndicators()"></health-indicators>
          }
        </div>
      </div>
    }
  </div>
</a>
